import React, { FC } from 'react'
import { LoanOfficerDisplayInfo } from '@mortgage-pos/types'
import { formatPhoneNumber } from '@mortgage-pos/utils'
import { popupCalendlyWidget } from '@shared-fe/utils/calendly'

export interface Props {
  loanOfficer: LoanOfficerDisplayInfo
  handleTalkToExpertClick?: () => void
  heading?: string
  body?: string
}

const LoanOfficerPopUp: FC<Props> = ({
  loanOfficer,
  heading,
  body = 'Have questions?',
}) => {
  const phoneNumber = loanOfficer?.phone
    ? formatPhoneNumber(loanOfficer.phone)
    : ''

  if (!loanOfficer) {
    return <></>
  }

  return (
    <div
      className="loan-officer-popup__container"
      data-testid="loan-officer-popup__container"
    >
      <img
        src={loanOfficer?.headshot}
        alt={`${loanOfficer?.name} headshot`}
        className="loan-officer-popup__headshot"
      />
      <div className="loan-officer-popup__text-container">
        <h1 className="loan-officer-popup__name">
          {heading ? heading : `Hi, I'm ${loanOfficer?.name}!`}
        </h1>

        <div>
          {body} Call or text me at
          <div>
            <span loan-officer-popup__phone> {phoneNumber}</span>
            {loanOfficer?.calendly_link ? (
              <span
                onClick={()=> popupCalendlyWidget(loanOfficer.calendly_link)}
                className="loan-officer-popup__hyperlink"
              >
                , or schedule a time here
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
export default LoanOfficerPopUp
